"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _HBMenuItem = _interopRequireDefault(require("./HBMenuItem"));
var _react = _interopRequireDefault(require("react"));
var _ArrowRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowRight16"));
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
var _HBMenu = require("./HBMenu.styles");
var _excluded = ["sectionTitle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _HBMenuList = function HBMenuList(_ref) {
  var menuItems = _ref.menuItems,
    size = _ref.size,
    subMenuSize = _ref.subMenuSize,
    hideArrowIconInSubmenu = _ref.hideArrowIconInSubmenu;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, menuItems.map(function (item, index) {
    switch (item.type) {
      case 'divider':
        return /*#__PURE__*/_react["default"].createElement(_HBMenu.StyledDivider, {
          key: index,
          margin: item.margin
        });
      case 'section':
        var sectionTitle = item.sectionTitle,
          restItem = (0, _objectWithoutProperties2["default"])(item, _excluded);
        return /*#__PURE__*/_react["default"].createElement(_HBMenuItem["default"], {
          key: index,
          size: size,
          item: _objectSpread(_objectSpread({}, restItem), {}, {
            type: 'item',
            title: /*#__PURE__*/_react["default"].createElement(_HBMenu.StyledSectionTitle, null, sectionTitle)
          }),
          dropdownReferenceType: "section"
        });
      case 'submenu':
        return /*#__PURE__*/_react["default"].createElement(_reactDropdownMenu.Sub, {
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_HBMenuItem["default"], {
          item: _objectSpread(_objectSpread({}, item), {}, {
            type: 'item'
          }, !hideArrowIconInSubmenu ? {
            rightIcon: /*#__PURE__*/_react["default"].createElement(_ArrowRight["default"], null)
          } : {}),
          size: size,
          dropdownReferenceType: "subTrigger"
        }), /*#__PURE__*/_react["default"].createElement(_HBMenu.StyledSubContent, {
          $maxHeight: item.maxHeight
        }, /*#__PURE__*/_react["default"].createElement(_HBMenuList, {
          menuItems: item.menuItems,
          size: subMenuSize || size
        })));
      default:
        return /*#__PURE__*/_react["default"].createElement(_HBMenuItem["default"], {
          item: item,
          size: size,
          key: index
        });
    }
  }));
};
var _default = exports["default"] = _HBMenuList;
//# sourceMappingURL=HBMenuList.js.map